<template>
  <basic-container>
    <avue-crud
      v-if="reWrite"
      :option="option"
      :table-loading="loading"
      :data="data"
      :page.sync="page"
      :permission="permissionList"
      :before-open="beforeOpen"
      v-model="form"
      ref="crud"
      @row-update="rowUpdate"
      @row-save="rowSave"
      @row-del="rowDel"
      @search-change="searchChange"
      @search-reset="searchReset"
      @selection-change="selectionChange"
      @current-change="currentChange"
      @size-change="sizeChange"
      @refresh-change="onLoad"
      @on-load="onLoad"
    >
      <template slot-scope="scope" slot="menu">
        <el-button
          type="text"
          size="small"
          icon="el-icon-setting"
          v-if="permissionList.authBtn"
          @click="authPassage(scope.row)"
          >通 道
        </el-button>
      </template>
    </avue-crud>
    <el-dialog title="岗亭通道绑定" append-to-body :visible.sync="box" width="345px">
      <el-tree
        :data="parkPassageList"
        show-checkbox
        node-key="id"
        ref="parkPassageList"
        :default-checked-keys="defaultCheckedKeyList"
        :props="props"
        @check-change="checkHandler"
        @node-click="nodeClickHandler"
      >
      </el-tree>
      <span slot="footer" class="dialog-footer">
        <el-button @click="box = false">取 消</el-button>
        <el-button type="primary" @click="submit" :disabled="submitDisabled" >确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog title="只读/编辑" append-to-body :visible.sync="readOrEditVisible" width="345px">
      <el-radio-group v-model="readOrEdit" @change="changeHandler">
        <el-radio label="1" disabled>只读</el-radio>
        <el-radio label="2" :disabled="!operatable">编辑</el-radio>
      </el-radio-group>

      <span slot="footer" class="dialog-footer">
        <el-button @click="readOrEditVisible = false">取 消</el-button>
        <el-button type="primary" @click="radioConfirm">确 定</el-button>
      </span>
    </el-dialog>
  </basic-container>
</template>

<script>
import {
  getBondPassages,
  sentryBoxBindPassage,
  add,
  getDetail,
  getList,
  remove,
  update,
} from '@/api/v4ward/park/sentry/parksentrybox';
import { passageSelections, passageList } from '@/api/v4ward/park/passage/parkpassage';
import { getSpaceTree } from '@/api/v4ward/car/carparkspace';
import { mapGetters } from 'vuex';

export default {
  data() {
    return {
      form: {},
      query: {},
      loading: true,
      reWrite: false,
      spaceList: [],
      tempParkingLotId: '',
      firstDisplayFlag: false,
      page: {
        pageSize: 10,
        currentPage: 1,
        total: 0,
      },
      selectionList: [],
      parkPassageList: [],
      checkedKeyList: [],
      defaultCheckedKeyList: [],
      readOrEdit: '2',
      readOrEditVisible: false,
      operatable: false,
      submitDisabled: false,
      currentTreeId: '',
      initTree: true,
      authId: '',
      box: false,
      props: {
        label: 'name',
        value: 'id',
      },
      option: {
        height: 'auto',
        //calcHeight: 30,
        tip: false,
        searchShow: true,
        searchMenuSpan: 6,
        border: true,
        index: true,
        viewBtn: true,
        selection: false,
        dialogClickModal: false,
        align: 'center',
        indexLabel: '序号',
        dialogWidth: '30%',
        labelWidth: 120,
        span: 24,
        columnBtn: false,
        refreshBtn:false,
        column: [
          {
            label: '车场名称',
            prop: 'parkingLotId',
            type: 'select',
            //dicUrl: '/api/v4ward/car/parkSpaceNode/treeChildrenCarParkNode?id=0',
            editDisabled: true,
            search: true,
            searchSpan: 5,
            props: {
              label: 'title',
              value: 'id',
              disabled: 'disabled',
            },
            rules: [
              {
                required: true,
                message: '请选择车场',
                trigger: 'change',
              },
            ],
          },
          {
            label: '岗亭名称',
            prop: 'sentryBoxName',
            search: true,
            searchSpan: 4,
            maxlength: 20,
            rules: [
              {
                required: true,
                message: '请输入岗亭名称',
                trigger: 'change',
              },
            ],
          },
          {
            label: '岗亭编号',
            prop: 'sentryBoxCode',
            search: true,
            searchSpan: 4,
            maxlength: 20,
            rules: [
              {
                required: true,
                message: '请输入岗亭编号',
                trigger: 'change',
              },
              { pattern: /^[a-zA-Z][a-zA-Z0-9]{3,11}$/, message: '编号只能包含字母和数字,且以字母开头,长度4-12' },
            ],
          },
          {
            label: '备注信息',
            prop: 'remark',
            type: 'textarea',
            minRows: 2,
            maxlength: 100,
            showWordLimit: true,
          },
        ],
      },
      data: [],
    };
  },
  computed: {
    ...mapGetters(['permission']),
    permissionList() {
      return {
        addBtn: this.vaildData(this.permission.parksentrybox_add, false),
        viewBtn: this.vaildData(this.permission.parksentrybox_view, false),
        delBtn: this.vaildData(this.permission.parksentrybox_delete, false),
        editBtn: this.vaildData(this.permission.parksentrybox_edit, false),
        authBtn: this.vaildData(this.permission.parksentrybox_auth, false),
      };
    },
    ids() {
      let ids = [];
      this.selectionList.forEach((ele) => {
        ids.push(ele.id);
      });
      return ids.join(',');
    },
  },
  created() {
    getSpaceTree().then((data) => {
      this.spaceList = data.data;
      if (this.spaceList.length > 0) {
        var spaceColumn = this.findObject(this.option.column, 'parkingLotId');
        spaceColumn.dicData = data.data;
        spaceColumn.searchValue = this.spaceList[0].id;
        this.query.parkingLotId = this.spaceList[0].id;
        this.tempParkingLotId = this.spaceList[0].id;
        this.$nextTick(() => {
          this.reWrite = true;
        });
      } else {
        this.$nextTick(() => {
          this.reWrite = true;
        });
      }
      this.onLoad();
    });
  },
  methods: {
    nodeClickHandler(){
      //console.log('11111');
      //this.readOrEditVisible = !this.readOrEditVisible;
    },
    checkHandler(data, selected, childSelected) {
      console.log(data, selected, childSelected);
      console.log(this.$refs.parkPassageList.getNode(data.id));
      let checkedNode = this.$refs.parkPassageList.getNode(data.id);
      this.operatable = data.operatable;
      if (selected) {
        this.readOrEditVisible = true;
        this.readOrEdit = data.readOrWrite+'';
        if (this.initTree) {
          return;
        }
        console.log('+++'+this.operatable);
        // let nodeLabel = data.passageName;
        // data.passageName += '-read';
        // this.$refs.parkPassageList.setCurrentNode(data);
        this.currentTreeId = data.id;
      } else {
        if (this.initTree) {
          return;
        }
        // data.passageName = data.passageName.split('-')[0];
        // this.$refs.parkPassageList.setCurrentNode(data);
        this.currentTreeId = '';
      }
    },
    radioConfirm() {
      this.readOrEditVisible = !this.readOrEditVisible;
      console.log(this.readOrEdit, this.currentTreeId);
      let checkedNode = this.$refs.parkPassageList.getNode(this.currentTreeId);
      if (parseInt(this.readOrEdit) == 1) {
        checkedNode.data.name = checkedNode.data.passageShortName + '---只读';
        checkedNode.data.readOrWrite = 1;
      }
      if (parseInt(this.readOrEdit) == 2) {
        checkedNode.data.name = checkedNode.data.passageShortName + '---编辑';
        checkedNode.data.readOrWrite = 2;
      }
    },
    changeHandler(value) {
      console.log(this.readOrEdit, this.currentTreeId);
      // let checkedNode = this.$refs.parkPassageList.getNode(this.currentTreeId);
      // if(parseInt(this.readOrEdit)==1){
      //   checkedNode.data.name = checkedNode.data.passageShortName + '---只读';
      // }
      // if(parseInt(this.readOrEdit)==2){
      //   checkedNode.data.name = checkedNode.data.passageShortName + '---编辑';
      // }
    },
    submit() {
      // const selectedList = this.$refs.parkPassageList.getCheckedKeys();
      let selectedList = this.$refs.parkPassageList.getCheckedNodes();
      selectedList.forEach((e, i) => {
        selectedList[i].checked = true;
        selectedList[i].name = selectedList[i].passageShortName;
      });
      console.log(JSON.stringify(selectedList));
      // return;
      // sentryBoxBindPassage({ sentryboxId: this.authId, passageIdList: selectedList }).then(() => {
      sentryBoxBindPassage({ id: this.authId, list: selectedList }).then(() => {
        this.box = false;
        this.$message({
          type: 'success',
          message: '操作成功!',
        });
        //this.onLoad(this.page);
      });
    },
    authPassage(row) {
      this.parkPassageList = [];
      let self = this;
      self.defaultCheckedKeyList = [];
      self.initTree = true;

      passageList({ id: row.id }).then((res) => {
        this.parkPassageList = res.data.list;
        if(this.parkPassageList.length === 0){
          //this.box=false;
          //this.$message.warning("请绑定通道信息后尝试！");
          this.submitDisabled = true;
          return;
        }
        this.submitDisabled = false;
        this.parkPassageList.forEach((element, index) => {
          self.parkPassageList[index].radioLabel = '';
          self.parkPassageList[index].passageShortName = element.name;
          if (element.checked) {
            self.defaultCheckedKeyList.push(element.id);
          }
          if (parseInt(element.readOrWrite) == 2) {
            self.parkPassageList[index].name =
              self.parkPassageList[index].passageShortName + '---编辑';
          }
          if (parseInt(element.readOrWrite) == 1) {
            self.parkPassageList[index].name =
              self.parkPassageList[index].passageShortName + '---只读';
          }
        });
        getBondPassages({ sentryboxId: row.id }).then((res) => {
          this.checkedKeyList = res.data.map((item) => {
            return item.passageId;
          });

          setTimeout(() => {
            this.initTree = false;
            /*this.document.querySelectorAll('div[class="el-tree-node__content"]').forEach((el) => {
              el.querySelector('label').addEventListener('click', () => {
                self.initTree = false;
              });
            });*/
          }, 0);
        });
      });
      this.authId = row.id;
      this.box = true;
    },
    rowSave(row, done, loading) {
      add(row).then(
        () => {
          this.onLoad();
          this.$message.success('操作成功!');
          done();
        },
        (error) => {
          window.console.log(error);
          loading();
        }
      );
    },
    rowUpdate(row, index, done, loading) {
      update(row).then(
        () => {
          this.onLoad();
          this.$message.success('操作成功!');
          done();
        },
        (error) => {
          window.console.log(error);
          loading();
        }
      );
    },
    rowDel(row) {
      this.$confirm('确定将选择数据删除?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          return remove({ id: row.id });
        })
        .then(() => {
          this.onLoad();
          this.$message.success('操作成功!');
        });
    },
    beforeOpen(done, type) {
      if (['edit', 'view'].includes(type)) {
        getDetail({ id: this.form.id }).then(({ data }) => {
          this.form = data;
        });
      }
      done();
    },
    searchReset() {
      this.query = {};
      //每次刷新页面时，开启车场搜索框默然显示第一个节点的名称
      this.firstDisplayFlag = true;
      this.onLoad();
    },
    searchChange(params, done) {
      this.query = params;
      this.page.currentPage = 1;
      this.onLoad();
      done();
    },
    selectionChange(list) {
      this.selectionList = list;
    },
    selectionClear() {
      this.selectionList = [];
      this.$refs.crud.toggleSelection();
    },
    currentChange(currentPage) {
      this.page.currentPage = currentPage;
    },
    sizeChange(pageSize) {
      this.page.pageSize = pageSize;
    },
    onLoad(page) {
      page = page || this.page;
      this.loading = true;
      //如果加载列表时parkingLotId为空，则将parkingLotId置为当前的第一个车场
      if (this.query.parkingLotId == undefined || this.query.parkingLotId == '') {
        this.query.parkingLotId = this.tempParkingLotId;
      }
      getList(Object.assign({ current: page.currentPage, size: page.pageSize }, this.query)).then(
        ({ data }) => {
          this.page.total = data.total;
          this.data = data.records;
          this.loading = false;
          this.selectionClear();
          if (this.firstDisplayFlag) {
            let ent = document.querySelector('input[placeholder="车场名称"]');
            ent.value = this.spaceList[0].title;
            this.query.parkingLotId = this.spaceList[0].id;
            //关闭默然显示，重刷页面时才开启默认显示
            this.firstDisplayFlag = false;
          }
        }
      );
    },
  },
};
</script>

<style>
</style>
